import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { Button } from 'react-bootstrap';
import inProgress from './in-progress.svg';
import DashboardAttribute from './DashboardAttribute';
import lineTest from './line-test.svg';

const LineTestTile = (props) => {
  const { customerInfo } = props;
  if (customerInfo.requestInProgress !== 'LineTest') {
    return null;
  }
  return (
    <div>
      {customerInfo.requestInProgress === 'testInProgress' &&
      <div className="account-action-tile">
        <img
          src={inProgress}
          alt={`${customerInfo.requestInProgress.changeType} request in progress`}
        />
        <h4 className="heading-title dashboard-attribute-header">
          Problem under investigation
        </h4>
        <div className="account-action-tile-text">
          We&#39;ll be in touch with updates on the progress of your issue.
          If you would like to get in touch with us concerning the problem,
          please quote the case number below.
        </div>
        <div>
          <DashboardAttribute label="Case Number">
            0123456444
          </DashboardAttribute>
        </div>
      </div>
      }
      {customerInfo.requestInProgress !== 'testInProgress' &&
      <div className="account-action-tile">
        <img
          src={lineTest}
          alt="Line Test"
        />
        <div className="account-action-tile-text">
          Check your Skinny Unlimited Broadband connection
        </div>
        <Button onClick={() => browserHistory.push('/line-test')}>Check Connection</Button>
      </div>
      }
    </div>
  );
};

LineTestTile.propTypes = {
  customerInfo: PropTypes.object
};

export default LineTestTile;



/** WEBPACK FOOTER **
 ** ./src/components/myaccount/Dashboard/LineTestTile.js
 **/